import { createFileRoute } from "@tanstack/react-router";
import HeroSection from "@/components/cbfeo-ao-vivo/HeroSection";
import AboutSection from "@/components/cbfeo-ao-vivo/AboutSection";
import ExperienceSection from "@/components/cbfeo-ao-vivo/ExperienceSection";
import SponsorsSection from "@/components/cbfeo-ao-vivo/SponsorsSection";
import AudienceSection from "@/components/cbfeo-ao-vivo/AudienceSection";
import VenueSection from "@/components/cbfeo-ao-vivo/VenueSection";
import SpeakersSection from "@/components/cbfeo-ao-vivo/SpeakersSection";
import ScheduleSection from "@/components/cbfeo-ao-vivo/ScheduleSection";
import TicketsSection from "@/components/cbfeo-ao-vivo/TicketsSection";

import GallerySection from "@/components/cbfeo-ao-vivo/GallerySection";
import FAQSection from "@/components/cbfeo-ao-vivo/FAQSection";
import RealizacaoSection from "@/components/cbfeo-ao-vivo/RealizacaoSection";
import FooterSection from "@/components/cbfeo-ao-vivo/FooterSection";
import { useCbfeoCheckoutUrl } from "@/hooks/use-cbfeo-checkout-url";
import { useInscricoesCbfeoEncerradas } from "@/lib/cbfeo/status";
import "@/styles/cbfeo.css";


export const Route = createFileRoute("/cbfeo-ao-vivo")({
  head: () => ({
    meta: [
      { title: "II CBFEO Ao Vivo | Transmissão do Congresso" },
      { name: "robots", content: "noindex, nofollow, noarchive" },
      { name: "description", content: "Presencial esgotado. Garanta acesso à transmissão ao vivo do II CBFEO 2026 por R$ 97, com 2 dias de palestras e certificado digital." },
      { property: "og:title", content: "II CBFEO Ao Vivo | Transmissão do Congresso" },
      { property: "og:description", content: "Presencial esgotado. Assista ao II CBFEO 2026 ao vivo com certificado por R$ 97." },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "II CBFEO Ao Vivo" },
      { name: "twitter:description", content: "Presencial esgotado. Assista ao vivo por R$ 97, com certificado." },
      



    ],
  }),
  component: CbfeoPage,
});


function CbfeoPage() {
  const checkoutUrl = useCbfeoCheckoutUrl();
  const encerradas = useInscricoesCbfeoEncerradas();
  return (
    <div className="cbfeo-scope">
      <main className="min-h-screen">
        <h1 className="sr-only">II CBFEO Ao Vivo · Transmissão ao vivo do II Congresso Brasileiro de Fisioterapia em Ortopedia e Traumatologia</h1>
        <HeroSection
          ctaHref="#ingresso-online"
          ctaLabel={encerradas ? "Inscrições encerradas" : "Garanta sua vaga"}
          ctaHeadline={encerradas ? "Inscrições encerradas" : "Assista de onde você estiver"}
          showHeadline={true}
        />



        <div id="sobre">
          <AboutSection />
        </div>
        <AudienceSection />
        <ExperienceSection />
        <SpeakersSection />


        <TicketsSection checkoutUrl={checkoutUrl} encerradas={encerradas} />

        <div id="cronograma">
          <ScheduleSection />
        </div>
        <VenueSection ctaHref="#ingresso-online" ctaLabel={encerradas ? "INSCRIÇÕES ENCERRADAS" : "GARANTA SUA VAGA"} />

        <GallerySection />



        <FAQSection />
        <SponsorsSection />
        <RealizacaoSection />
        <FooterSection />
      </main>
    </div>
  );
}

